import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CardWrapper from './CardWrapper';

export default function InactiveCard({ reason }) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'procore.fileDestination.components.cards.InactiveCard',
  });

  return (
    <CardWrapper isInactive={true}>
      <div className='tw-text-grey-900'>{i18nT('title')}</div>
      <div className='tw-text-s tw-font-normal tw-tracking-wide'>{reason}</div>
    </CardWrapper>
  );
}

InactiveCard.propTypes = {
  reason: PropTypes.node,
};
